export default __webpack_public_path__ + "static/media/Featured_ribbon.191087ec.svg";